import { useEffect } from 'react'
import { useMap } from 'react-leaflet'
import { FullScreen } from 'leaflet.fullscreen'

const FullscreenControl = (): void => {
  const map = useMap()

  useEffect(() => {
    const control = new FullScreen({ position: 'topleft' })
    map.addControl(control)
    return () => { map.removeControl(control) }
  }, [map])
}

export default FullscreenControl
